/**
 * Seeded Rosie system role keys (user.type for system accounts).
 * Custom roles may also be stored on user.type — load those via useRosieRoles / the roles API.
 * Keep in sync with backend RosieUserType / SYSTEM_ROLE_KEYS.
 *
 * - admin: per-user permissions; only type allowed into admin-only sections
 * - user: per-user permissions; never allowed into admin-only sections
 * - scla-fellow: locked role — permissions always equal the Fellow role template
 *
 * Unrestricted access is NOT a type — holders use permissions: ['*'].
 */
// eslint-disable-next-line import/prefer-default-export, no-shadow
export enum RosieUserTypeEnum {
  ADMIN = 'admin',
  USER = 'user',
  SCLA_FELLOW = 'scla-fellow',
}

/** Ordered system role values for static pickers / filters. */
export const ROSIE_USER_TYPE_VALUES = [
  RosieUserTypeEnum.ADMIN,
  RosieUserTypeEnum.USER,
  RosieUserTypeEnum.SCLA_FELLOW,
] as const;

export type RosieSystemUserType = (typeof ROSIE_USER_TYPE_VALUES)[number];

/** @deprecated Use RosieUserTypeEnum */
export const UserTypeEnum = RosieUserTypeEnum;
